<div class="parallax" *ngIf="!loadBestOffers && bestSalesOffers.length>0">
    <div class="title">
        <h1>
            <strong>Nos offres </strong>
        </h1>
    </div>
    <div class="container">
        <div *ngIf="loadBestOffers" id="loadingPage"></div>
        <div class="bestSales" [ngClass]="{'d-flex justify-content-center':bestSalesOffers.length<5}" *ngIf="!loadBestOffers">
            <div class="prod" *ngFor="let menu of bestSalesOffers;let i=index">
                <menu-card (OnAdd)="OpenMenuModal(i)" [menu]="menu"></menu-card>
            </div>
        </div>
    </div>
</div>